export default __webpack_public_path__ + "static/media/Codagence_main_logo.a0229b9e.png";